import { render } from "./WizardButton.vue?vue&type=template&id=766e5fb3"
import script from "./WizardButton.vue?vue&type=script&lang=js"
export * from "./WizardButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__